import React from 'react';
import ContentManager from './ContentManager';
import { getProducts, createProduct, updateProduct, deleteProduct } from '../../api';

const Products = () => {
  const fields = [
    { name: 'name', label: 'Product Name', type: 'text', required: true },
    { name: 'description', label: 'Description', type: 'textarea', rows: 3, required: true },
    { name: 'order', label: 'Display Order', type: 'number', defaultValue: 0 }
  ];

  return (
    <ContentManager
      title="Products Management"
      itemLabel="Product"
      fields={fields}
      fetchFn={getProducts}
      createFn={createProduct}
      updateFn={updateProduct}
      deleteFn={deleteProduct}
    />
  );
};

export default Products;
